import { render } from "./UploadInFolder.vue?vue&type=template&id=e2acf976"
import script from "./UploadInFolder.vue?vue&type=script&lang=js"
export * from "./UploadInFolder.vue?vue&type=script&lang=js"

import "./UploadInFolder.vue?vue&type=style&index=0&id=e2acf976&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__